module.exports = __webpack_public_path__ + "static/reasons-and-persons-b2ee7f566b9e00015462eb363e700ff5.jpg";